import { get, isUndefined } from "lodash"

/**
 * A minimal wrapper around Pendo's client `track` method
 * https://support.pendo.io/hc/en-us/articles/360032294291-Track-Events-Configuration#client-side-agent-0-12)
 *
 * Sends data to Pendo's Track Events dashboard for events that
 * aren’t automatically captured as click events or page load events.
 *
 * @param {string} event - the name of the Track Event
 * @param {Object} [properties={}] - free-form dictionary of properties of the event
 */

const pendoTrackEvent = (event, properties = {}) => {
  if (isUndefined(get(window, "pendo"))) {
    return console.warn("`window.pendo` is undefined") // eslint-disable-line no-console
  }

  window.pendo.track(event, properties)
}

export default pendoTrackEvent
